import React, { useEffect, useRef } from "react";
import { loadStripe, Stripe, StripeEmbeddedCheckout } from "@stripe/stripe-js";
import { toast } from "react-toastify";
import stripeKey from "../../../Utils/Stripe/StripeKey";

const StripeEmbedPaymentForm = ({ clientSecret }: { clientSecret: string }) => {
  const divRef = useRef<HTMLDivElement | null>(null);

  const stripeRef = useRef<Stripe | null>(null);
  const checkoutInstanceRef = useRef<StripeEmbeddedCheckout | null>(null);

  useEffect(() => {
    if (!clientSecret) return;

    const initializeCheckout = async () => {
      try {
        if (!stripeKey) {
          throw new Error("Stripe is not configured (REACT_APP_PAYMENT_KEY).");
        }

        const stripe = await loadStripe(stripeKey);
        if (!stripe) throw new Error("Failed to load Stripe.");

        stripeRef.current = stripe;
        window.onbeforeunload = null;

        const checkout = await stripe.initEmbeddedCheckout({
          clientSecret,
          onComplete: () => {
            toast.success("Payment successful!");
            window.onbeforeunload = null;
            // Destroy the checkout instance
            if (checkoutInstanceRef.current) {
              checkoutInstanceRef.current.destroy();
              checkoutInstanceRef.current = null;
            }
          },
        });

        if (divRef.current) {
          checkout.mount(divRef.current);
          checkoutInstanceRef.current = checkout;
        }
      } catch (error: any) {
        toast.error(error.message || "Error initializing checkout");
      }
    };

    initializeCheckout();

    return () => {
      window.onbeforeunload = null; // Clear on cleanup
      if (checkoutInstanceRef.current) {
        checkoutInstanceRef.current.destroy();
      }
    };
  }, [clientSecret]);

  return <div id="checkout" ref={divRef} />;
};

export default StripeEmbedPaymentForm;
